// extracted by mini-css-extract-plugin
export default {"gradientWrapper":"GradientBackdrop_gradientWrapper__p7EFP"};